import { Directive, HostListener, Input, OnChanges, SimpleChanges } from '@angular/core';
/**
 * Directive for preventing input in textbox
 */
@Directive({
  selector: '[inputRestrict]'
})
export class InputRestrictDirective implements OnChanges{
  /** List of Regex to be checked */
  private regexMap: object;
  /** Current regec placed over the directive*/
  private regexMatch: RegExp;
  /** Object Initialization */
  constructor() {
    this.regexMap = {
      unsignedInteger:/^[0-9]*$/g,
      signedInteger :/^-?[0-9]+$/g,
      unsignedFloat: /^[0-9\.]$/g,
      signedFloat: /^[+-]?([0-9]*[.])?[0-9]+$/g,
      alphanumeric: /^[A-Za-z0-9]$/g,
      words: /^([A-Za-z-\s'\.]*)*$/g,
      alphabets: /^[A-z]*$/g,
      email: /^[A-Za-z0-9._%+-@.]*$/g,
      name: /^([A-Za-z-\s'\.]*)*$/g,
      password: /^[A-Za-z0-9!@#$%^&*]$/g,
      alphaNumericWords: /^([0-9A-z-\s\']*)*$/g,
    }
  }
  /** Input Value for Directive*/
  @Input('inputRestrict') inputRestrict: string;
  
  /**
   * Life cycle Hook for listening to changes
   * @param changes Simple Changes Instance
   */
  ngOnChanges(changes: SimpleChanges){
    if(changes['inputRestrict'] && changes['inputRestrict'].currentValue){
      this.regexMatch = this.regexMap[changes['inputRestrict'].currentValue];
    }
  }
  
  /** Listener for Keypress event to check for valid Input */
  @HostListener('keypress', ['$event']) onkeypress(e){
    let event = e || window.event;
    if(event){
      let key=event.keyCode || event.charCode;
      if(event && this.regexMatch && key!=13){
        return String.fromCharCode(key).match(this.regexMatch)!=null;
      }else{ return true;}
    } else{ return true;}
  }
}